import React, { Component } from 'react';
import Employee from 'services/api/Employee';
import store from 'store';
import { patchEmployeeInApiCaches } from 'store/app/entities/EmployeesApiSlice';
import { object, string } from 'prop-types';
import { Box } from '@mui/material';
import PhotoUpload from 'components/controls/PhotoUpload';
import connector from './connector';

class ChangeAvatar extends Component {
  uploadAvatar = async file => {
    // eslint-disable-next-line camelcase -- prop name from parent
    const { actions, employee_id, avatar: previousAvatar } = this.props;

    if (!(file instanceof File || file instanceof Blob)) {
      return;
    }

    const previewUrl = URL.createObjectURL(file);
    actions.employees.modify(employee_id, { avatar: previewUrl });
    patchEmployeeInApiCaches(store.dispatch, store.getState, employee_id, { avatar: previewUrl });

    try {
      await Employee.uploadAvatar(employee_id, file);
    } catch (error) {
      URL.revokeObjectURL(previewUrl);
      actions.employees.modify(employee_id, { avatar: previousAvatar || '' });
      patchEmployeeInApiCaches(store.dispatch, store.getState, employee_id, {
        avatar: previousAvatar || '',
      });
      throw error;
    }
  };

  render() {
    const { className, avatar } = this.props;
    return (
      <Box className={className} sx={{ display: 'flex', alignItems: 'center' }}>
        <PhotoUpload
          classes={{ root: { marginBottom: 0 } }}
          name="Edit photo"
          edit
          circle
          onChange={this.uploadAvatar}
          value={avatar}
        />
      </Box>
    );
  }
}

ChangeAvatar.propTypes = {
  className: string,
  avatar: string,
  employee_id: string.isRequired,
  actions: object.isRequired,
};

ChangeAvatar.defaultProps = {
  className: '',
  avatar: '',
};

export default connector(ChangeAvatar);
